import { UTILITY_URL } from "../../../configs/WebServiceUrl";

/**
 * Configuration and endpoints for Stage Utility API (STEM Projects, Stages, etc.)
 */
export const STAGE_UTILITY_API_BASE_URL = `${UTILITY_URL}/api/v1`;

export const STEM_CATEGORY_ID = 1;

export const getStageUtilityHeaders = () => {
  const token =
    localStorage.getItem("sms_auth_token") ||
    localStorage.getItem("userToken") ||
    localStorage.getItem("dmadmn_token");

  let userId = null;
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    userId = userData?.id || userData?.user_id || userData?.admin_id || null;
  } catch {
    userId = null;
  }

  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(userId ? { "x-user-id": String(userId) } : {}),
  };
};
